import Axios from 'axios'
import GetToken from './GetToken'
import Appointments from './Appointments'

class CFOAuthApi {
  public readonly getToken: ReturnType<typeof GetToken>
  public readonly appointments: ReturnType<typeof Appointments>
  constructor() {
    // Server-side token endpoint - no sensitive credentials exposed
    const axiosInstanceToken = Axios.create({
      baseURL: '/api/cfo',
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    
    // Server-side appointments endpoint
    const axiosInstanceAppointments = Axios.create({
      baseURL: '/api/cfo',
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    
    this.getToken = GetToken(axiosInstanceToken)
    this.appointments = Appointments(axiosInstanceAppointments)
  }
}

export default function createCFOApiClient(): CFOAuthApi {
  return new CFOAuthApi()
}
